'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW = exports.SHOW = '@@snackbar/SHOW';
var DISMISS = exports.DISMISS = '@@snackbar/DISMISS';